import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UploadImageCautionArea = _resolveComponent("UploadImageCautionArea")!
  const _component_AvatarImage = _resolveComponent("AvatarImage")!
  const _component_UploadImageForm = _resolveComponent("UploadImageForm")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_UploadImageCautionArea, {
      cautions: _ctx.cautions,
      class: "mb-4"
    }, {
      default: _withCtx(() => [
        _createTextVNode("\n      ※インカメラでの撮影を推奨します\n    ")
      ], undefined, true),
      _: 1
    }, 8, ["cautions"]),
    _createTextVNode(),
    _createVNode(_component_UploadImageForm, {
      modelValue: _ctx.inputValues.avatar,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.inputValues.avatar) = $event)),
      photoGraphingType: "avatar",
      appLabelText: "必須",
      appLabelVariant: "red",
      isCameraActive: _ctx.isCameraActiveValue,
      "onUpdate:isCameraActive": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.isCameraActiveValue) = $event)),
      options: _ctx.options,
      disabled: _ctx.disabled,
      disabledText: _ctx.disabledText
    }, {
      default: _withCtx(() => [
        _createVNode(_component_AvatarImage, {
          imageUrl: _ctx.inputValues.avatar
        }, null, 8, ["imageUrl"])
      ], undefined, true),
      _: 1
    }, 8, ["modelValue", "isCameraActive", "options", "disabled", "disabledText"])
  ]))
}